/* istanbul ignore file */
import { useOneStopRequestsUrl, Request } from 'domain/shared/oneStop';
import { Link } from 'react-router-dom';
import { SearchResultField } from 'framework/ui/field';
import { Box, Typography } from '@mui/material';

type OneStopSearchResultsProps = {
  row: Request;
  index: number;
  focusedResultIndex: Nullable<Number>;
  searchResultsRefs: HTMLAnchorElement[];
  onKeyUp: (event: any, index: number) => void;
  setFocusToResults: () => void;
};

const OneStopSearchResults = ({
  row,
  index,
  onKeyUp,
  searchResultsRefs,
  focusedResultIndex,
  setFocusToResults,
}: OneStopSearchResultsProps) => {
  const { getSingleEntityUrl } = useOneStopRequestsUrl();
  const requestUrl = getSingleEntityUrl(row.id);

  return (
    <Box
      component={Link}
      key={row.id}
      to={requestUrl}
      onKeyUp={event => onKeyUp(event, index)}
      onFocus={setFocusToResults}
      ref={(link: HTMLAnchorElement | null) => {
        if (link) {
          // eslint-disable-next-line no-param-reassign
          searchResultsRefs[index] = link;
        }
      }}
      sx={theme => ({
        color: 'inherit',
        display: 'block',
        padding: '15px 16px',
        marginBottom: '12px',
        backgroundColor: focusedResultIndex === index ? theme.palette.common.menuItemActive : undefined,
        '&:hover, &:focus': {
          backgroundColor: theme.palette.common.menuItemActive,
          color: 'inherit',
          outline: 'none',
          textDecoration: 'none',
        },
      })}
    >
      <Typography variant="h2" color="primary">
        <SearchResultField source="title" value={(item: any) => `${item.id}. ${item.title}`} />
      </Typography>
      <SearchResultField source="category" value={(item: any) => `Category: ${item.sectionTitle}`} />
      {row.description && (
        <SearchResultField
          source="description"
          value={(item: any) => `Description: ${item.shortDescription || item.description}`}
        />
      )}
    </Box>
  );
};

export default OneStopSearchResults;
